import * as React from 'react';

const DocumentsIcon = ({
  height,
  width,
}: {
  height: number;
  width: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 22"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
  >
    <path d="M4.919 13.4805H13.056M2.182 1.255C1.92185 1.26139 1.67451 1.36925 1.4928 1.55554C1.31109 1.74182 1.20942 1.99177 1.2095 2.252V19.753C1.20942 20.0131 1.31102 20.263 1.49262 20.4493C1.67422 20.6356 1.92144 20.7435 2.1815 20.75H15.7935C16.0579 20.75 16.3115 20.645 16.4985 20.458C16.6855 20.271 16.7905 20.0174 16.7905 19.753V6.236H12.802C12.5418 6.2296 12.2943 6.12168 12.1126 5.93528C11.9309 5.74889 11.8293 5.49882 11.8295 5.2385V1.25L2.182 1.255ZM11.7845 1.255L16.7655 6.236L11.7845 1.255ZM4.919 10.464H13.056H4.919ZM4.919 16.497H13.056H4.919Z" />
  </svg>
);

export default DocumentsIcon;
